import { useCallback } from "react";
import { ServiceEnvironment } from "Enums/ServiceEnvironment";
import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";
import { z } from "zod";
import { ScopeItem } from "Shared/Components/Scope/Scopes.types";
import { useORPCClient } from "Core/oRPC";

export const useSubstrateFaultZone = () => {
    const orpcClient = useORPCClient();

    const getFaultZoneList = useCallback(
        async (env?: ServiceEnvironment, workload?: string, selectedScopesSoFar?: ScopeItem[]): Promise<ScopeItem[]> => {
            const selectedRegion = selectedScopesSoFar?.find((scope) => scope.ScopeType?.toLowerCase() === "region");
            const skipRegionFilter = !selectedRegion || selectedRegion.Value?.toLowerCase() === "all";
            const faultZoneRequest = {
                Environment: env,
                Workload: workload || "",
                TargetType: CentralAdminEntityType.FaultZone,
                FilterType: skipRegionFilter ? undefined : CentralAdminEntityType.Region,
                FilterValue: skipRegionFilter ? undefined : selectedRegion.Value?.toUpperCase()
            };
            const faultZoneOutput = await orpcClient.inventoryApi.postTopology(faultZoneRequest);
            const faultZoneParsedOutput = z.array(z.string()).parse(faultZoneOutput);
            const allOption: ScopeItem = { ScopeType: "FaultZone", Value: "All" };
            return [
                allOption,
                ...faultZoneParsedOutput.map((item) => ({
                    ScopeType: "FaultZone",
                    Value: item
                }))
            ];
        },
        [orpcClient]
    );

    return {
        getFaultZoneList
    };
};
